import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { AdminPanel } from "@/components/admin/AdminPanel";

export default function AdminPage() {
  const [, navigate] = useLocation();
  const { user, loading } = useAuth();

  // Simple admin check - in production, implement proper admin verification
  const isAdmin = user?.uid === 'admin';

  useEffect(() => {
    if (!loading && !isAdmin) {
      navigate("/chat");
    }
  }, [user, loading, isAdmin, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[hsl(128,60%,54%)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <AdminPanel
      isOpen={true}
      onClose={() => navigate("/chat")}
      isAdmin={isAdmin}
    />
  );
}
